import { render, staticRenderFns } from "./DataModal.vue?vue&type=template&id=48f51c22&scoped=true&"
import script from "./DataModal.vue?vue&type=script&lang=ts&"
export * from "./DataModal.vue?vue&type=script&lang=ts&"
import style0 from "./DataModal.vue?vue&type=style&index=0&id=48f51c22&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f51c22",
  null
  
)

export default component.exports